import { useState } from 'react';
import { useBorneStore } from '../store/borne-store';
import { agentClient } from '../services/agent-client';
import { AdminLoginDialog } from './AdminLoginDialog';

export function BlockedOverlay() {
  const blockReason = useBorneStore((s) => s.blockReason);
  const retryCount = useBorneStore((s) => s.retryCount);
  const navigate = useBorneStore((s) => s.navigate);
  const showToast = useBorneStore((s) => s.showToast);
  const unblock = useBorneStore((s) => s.unblock);
  const [showAdmin, setShowAdmin] = useState(false);
  const [unlocking, setUnlocking] = useState(false);

  function handleAdminSuccess() {
    setShowAdmin(false);
    navigate('admin');
  }

  async function handleUnlock() {
    setUnlocking(true);
    const ok = await agentClient.executeUnlockSequence();
    setUnlocking(false);
    if (ok) {
      unblock();
      showToast('Caisse debloquee', 'success');
    } else {
      showToast('Echec du deblocage', 'error');
    }
  }

  if (showAdmin) {
    return <AdminLoginDialog onSuccess={handleAdminSuccess} onCancel={() => setShowAdmin(false)} />;
  }

  return (
    <div className="overlay">
      <div className="flex flex-col items-center gap-6 px-8 animate-fade-in">
        {/* Warning icon */}
        <svg width="80" height="80" viewBox="0 0 64 64" className="text-warning">
          <path
            d="M32 6L4 58h56L32 6z"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinejoin="round"
          />
          <line x1="32" y1="26" x2="32" y2="40" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
          <circle cx="32" cy="48" r="2.5" fill="currentColor" />
        </svg>

        <p className="text-xl text-white text-center font-semibold max-w-md">
          {blockReason ?? 'Connexion perdue'}
        </p>

        {/* Spinner + retry count */}
        <div className="flex items-center gap-3">
          <svg width="24" height="24" viewBox="0 0 24 24" className="animate-spin text-white/60">
            <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2.5" strokeOpacity="0.25" />
            <path
              d="M12 2a10 10 0 0 1 10 10"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
          <span className="text-white/60 text-sm">
            Tentative de reconnexion #{retryCount}
          </span>
        </div>

        {/* Action buttons */}
        <div className="flex gap-3 mt-4">
          <button
            type="button"
            className="bg-warning text-black font-semibold px-6 py-3 rounded-xl transition-all active:scale-95 disabled:opacity-40"
            onClick={handleUnlock}
            disabled={unlocking}
          >
            {unlocking ? 'Deblocage...' : 'DEBLOQUER LA CAISSE'}
          </button>
          <button
            type="button"
            className="btn-primary text-base tracking-wider"
            onClick={() => setShowAdmin(true)}
          >
            ADMINISTRATION
          </button>
        </div>
      </div>
    </div>
  );
}
